import styled from "styled-components";

import "dayjs/locale/ja"; // 日本語ロケールをインポート
import color from "constants/color";
import font from "constants/font";
import { formatDuration } from "utils/formatDurationUtils";

const Wrap = styled.div``;

const Title = styled.div`
  font-weight: bold;
  font-size: ${font.size14};
`;

const DurationWrap = styled.div`
  border-radius: 5px;
  background-color: ${color.attentionLight};
  margin: 4px 0;
  width: fit-content;
`;

const Content = styled.div`
  opacity: 1;
  color: ${color.text.black};
  padding: 24px 28px;
  font-weight: bold;
  font-size: ${font.size16};
`;

const SystemNotificationDuration = ({ end, start, title }: { title: string; start: string; end: string }) => {
  const formattedDuration = formatDuration(start, end);
  return (
    <Wrap>
      <Title>{title}</Title>
      <DurationWrap>
        <Content>{formattedDuration}</Content>
      </DurationWrap>
    </Wrap>
  );
};

export default SystemNotificationDuration;
